import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { translate } from '../trans'
import store from '@/store'
import BooleanInjectableComponent from '../components/BooleanInjectableComponent';
import { i18n } from '@/plugins/i18n';



const NonCustomizedBenefitHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("CoverageIdentity/Current/Translations[]/Name", {
      getString: (item) => translate2(item.CoverageIdentity.Current, "Name")
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true
  })
];
export default NonCustomizedBenefitHeaders;